import { g as getRoomType } from './get-room-type.js';
import './index2.js';

/**
 * **Phobs - New Version**
 *
 * @exports bs_376
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};
  const hotelIdList = {

    1011377: {
      companyId: '7f5ead65275738bf2836dcdb94caabd2',
      hotelId: 'c2ffe924d4d40bb13ba38135d64b4870',
    },
    1011378: {
      companyId: '7f5ead65275738bf2836dcdb94caabd2',
      hotelId: '2b62b28b610ce52dfef50d7711706e76',
    },
    1011379: {
      companyId: '7f5ead65275738bf2836dcdb94caabd2',
      hotelId: '7cd6104971011f7e5c7fc601c22f53c7',
    },
    1011380: {
      companyId: '7f5ead65275738bf2836dcdb94caabd2',
      hotelId: 'e2db65d41fdd1d5e0b4646a4eaba18fc',
    },
    1011381: {
      companyId: '7f5ead65275738bf2836dcdb94caabd2',
      hotelId: 'ea21b3bc9697a893d269c2e1dba29e91',
    },
    1025089: {
      companyId: 'e176d39d6db85e038e37499a24a57e98',
      hotelId: 'cb86f2e1a1baa6705549bb624f52fc89',
    },
    1025090: {
      companyId: 'e176d39d6db85e038e37499a24a57e98',
      hotelId: '938f74001fffea6c6945eadfbc0dbd52',
    },
    1025093: {
      companyId: 'e176d39d6db85e038e37499a24a57e98',
      hotelId: '149ecc5dc015906e8b64c2abad0609ef',
    },
    1025094: {
      companyId: 'e176d39d6db85e038e37499a24a57e98',
      hotelId: '321193ef1c76d8fb07d8440ec896a8d8',
    },
    1025095: {
      companyId: 'e176d39d6db85e038e37499a24a57e98',
      hotelId: '792c0b90f388174b25f959ba9cd64dca',
    },
    1025096: {
      companyId: 'e176d39d6db85e038e37499a24a57e98',
      hotelId: 'a83ba856c104c717d6f61af65d8b678f',
    },
    1025825: {
      companyId: '623423995f029d48852be848b22db50d',
      hotelId: '1d36fe6d6842de07a5d6eb7aa580942d',
    },
    1027147: {
      companyId: 'd1fc319972168f2b9540913b7716c',
      hotelId: 'c45d2e2974c5a1e9d91a14c298a5b044',
    },
    1029353: {
      companyId: '569153d9afa6bac4b4c7d759ee1a60cd',
      hotelId: 'cc774b5e439bdd177f7db6ddc20ebabe',
    },
    1039241: {
      companyId: 'c04ff4560226b5f10bfe3fc138ed3f54',
      hotelId: '5f2c34c775bcd3037aa6ab3981a48802',
    },
    1043901: {
      companyId: '6ef433172c43f786339b4be5c8b86716',
      hotelId: '188fe500958e98d92aef4dbf3b9892e1',
    },
    1046137: {
      companyId: 'f10d19a83e2b113e203aaae0288123d1',
      hotelId: 'd65f1c0ecf364f5bf9731c25c52659ae',
    },
    1046138: {
      companyId: 'f10d19a83e2b113e203aaae0288123d1',
      hotelId: '87b98b2491d062ab009d42b3d6ca2fe0',
    },
    1046139: {
      companyId: 'f10d19a83e2b113e203aaae0288123d1',
      hotelId: '89547b6c89cd7fc3cd055c613f0e1e99',
    },
    1046140: {
      companyId: 'f10d19a83e2b113e203aaae0288123d1',
      hotelId: '967210bf7da870fa54acd1f12b7e26b5',
    },
    1046141: {
      companyId: 'f10d19a83e2b113e203aaae0288123d1',
      hotelId: 'd65f1c0ecf364f5bf9731c25c52659ae',
    },
    1046142: {
      companyId: 'f10d19a83e2b113e203aaae0288123d1',
      hotelId: '297ad37281d712618fc4cbe8f53bfcc4',
    },
    1046143: {
      companyId: 'f10d19a83e2b113e203aaae0288123d1',
      hotelId: '712257cb9c5f7aa3bfe83896ca0b9408',
    },
    1048393: {
      companyId: 'e8749b35b6eed720415ba06aa9341c09',
      hotelId: '26af404351b48132ba45eebf2c41c880',
    },
    1048628: {
      companyId: '2a019101d40c5498279f921d66d6188b',
      hotelId: '63efa8a30dac09ae62c789c59a6c6a50',
    },
    1045009: {
      companyId: 'ad31d8ffd56c153479516e6da851668c',
      hotelId: '0f47cd486eb03f7326f2df2492540a53',
    },
  };

  /**
     * @memberOf module:bs_376
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {

      const language = thn.parseUrlParameter('ibelang') || document.querySelector('input[name=lang]')?.value || document.querySelector('.header__lang [aria-current=page]')?.textContent?.toLowerCase();

      if (language && ctx.langs.test(language)) {
        resolve(language);
        return;
      }

      reject('no_language');
    });
  };

  /**
   * @memberOf module:bs_376
   * @see {@link generate_search_url}
   *
   * @param {object} ctx - The context object.
   */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {
    // https://secure.phobs.net/booking.php?company_id=ad31d8ffd56c153479516e6da851668c&hotel=0f47cd486eb03f7326f2df2492540a53
    const url = new URL(ctx.baseUrl);
    const validUrl = url.pathname.match(/booking|book/);

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }

    const searchParams = new URLSearchParams();
    searchParams.set('company_id', hotelIdList[thn.data.propertyId]?.companyId);
    searchParams.set('hotel', hotelIdList[thn.data.propertyId]?.hotelId);
    searchParams.set('date', '[date_begin]');
    searchParams.set('nights', '[nights]');
    searchParams.set('lang', thn.data.language || 'en');

    url.search = searchParams.toString();
    ctx.newData.dateBegin = ctx.newData.dateBegin.replace(/\//g, '-');
    ctx.newUrl = url.toString();
    return ctx;
  };

  /**
     * @memberOf module:bs_376
     * @see {@link onStateChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onStateChange = thn.debounce(function () {
    thn.languageCheck();
    thn.pageCheck();
  }, 800);

  /**
     * @memberOf module:bs_376
     * @see {@link is_user_logged}
     *
     * @param {object} ctx - The context object.
     */
  engine.isUserLogged = function isUserLogged(ctx) {
    return false;
  };

  /**
    * @memberOf module:bs_376
    * @see {@link prestart}
    *
    * @param {object} ctx - The context object.
    */
  engine.boot = function boot() {
    const container = document.documentElement;

    if (container) {
      const debouncedRefresh = thn.debounce(thn.pageCheck, 600);

      const pageUpdate = function updatePage(mutations) {
        const validMutationsCalendar = [...mutations].map((mutation) => ((mutation?.type === 'childList') && mutation?.target?.firstElementChild?.className?.match?.(/page page--2/))).filter((mapResult) => !thn.empty(mapResult));
        if (validMutationsCalendar) {
          debouncedRefresh();
        }
      };

      thn.observeDom(container, pageUpdate, {
        childList: true,
        subtree: true,
        attributes: false,
      });

      thn.shutdown(() => {
        debouncedRefresh.cancel();
        thn.stopObserveDom(container, pageUpdate);
      });
    }

  };

  /**
  * @memberOf module:bs_376
  * @this thn.widgets.price
  * @see {@link Price#set_data}
  *
  * @param {object} ctx - The context object.
  */
  engine.priceParseData = function priceParseData(ctx) {
    const widgetData = {};
    const usersWant2PeopleOrMore = [1049152].includes(thn.data.accountUserId);
    let roomInfo = [];

    // Dates
    let nights;
    const dateBegin = thn.parseUrlParameter('checkin').replace(/-/g, '/');
    const dateEnd = thn.parseUrlParameter('checkout').replace(/-/g, '/');

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin;
      widgetData.dateEnd = dateEnd;
      nights = thn.daysBetween(dateBegin, dateEnd);
    }

    // Guests, Adults & Children
    if (usersWant2PeopleOrMore) {
      roomInfo = [...document.querySelectorAll('.unit:not(.unit--hidden) .unit__rate-plan-price-container')]
        .filter((el) => thn.parseNumber(el?.nextSibling?.nextSibling?.textContent) !== 1)
        .map((el) => {
          const adults = thn.parseNumber(el?.nextSibling?.nextSibling?.textContent);
          const price = thn.parseNumber(el?.querySelector('.unit__rate-plan-price')?.textContent);
          const currency = thn.parseCurrency(el?.querySelector('span')?.textContent);
          return { adults, price, currency };
        });
    }

    if (roomInfo.length === 0) {
      roomInfo = [...document.querySelectorAll('.unit:not(.unit--hidden) .unit__rate-plan-price-container')].map((el) => {
        const adults = thn.parseNumber(el?.nextSibling?.nextSibling?.textContent);
        const price = thn.parseNumber(el?.querySelector('.unit__rate-plan-price')?.textContent);
        const currency = thn.parseCurrency(el?.querySelector('span')?.textContent);
        return { adults, price, currency };
      });
    }
    roomInfo.sort((a, b) => a.price - b.price);

    const adults = thn.parseNumber(document.querySelectorAll('.unit.mg-top-4:not(.unit--hidden) .card.unit-card')[0]?.querySelectorAll('.fa-male').length) || 0;
    const children = thn.parseNumber(document.querySelectorAll('.unit.mg-top-4:not(.unit--hidden) .card.unit-card')[0]?.querySelectorAll('.fa-child').length) || 0;

    widgetData.adults = adults > roomInfo[0].adults ? roomInfo[0].adults : adults;
    widgetData.children = (adults + children) > roomInfo[0].adults ? ((roomInfo[0].adults - adults) > 0 ? (roomInfo[0].adults - adults) : 0) : children;
    widgetData.guests = thn.parseNumber(widgetData.adults) + thn.parseNumber(widgetData.children);

    // Prices
    const lowestPrice = roomInfo[0]?.price;

    // Currency
    const currency = roomInfo[0]?.currency;

    // No availability
    const noAvailability = document.querySelector('.info-box .fa-triangle-exclamation');

    if (!thn.empty(lowestPrice) && currency) {
      widgetData.price = lowestPrice / nights;
      widgetData.currency = currency;
      widgetData.roomDetails = engine._roomDetailsParseData();
      widgetData.set = true;
    } else if (noAvailability) {
      widgetData.noRooms = true;
    }

    return widgetData;

  };

  /**
    *
    * @memberOf module:bs_376
    *
    */
  engine._roomDetailsParseData = function roomDetailsParseData() {
    const roomsInfo = document.querySelectorAll('.card.unit-card');
    const roomDetailsArray = [];
    roomsInfo?.forEach((room) => {
      const roomName = room.querySelector('.card__title-inner span')?.textContent;
      const roomAdults = room.querySelectorAll('.fa-male').length;
      const roomChildren = room.querySelectorAll('.fa-child').length;
      const roomType = getRoomType(roomName);
      const roomData = {
        id: '',
        name: roomName,
        adults: roomAdults,
        children: roomChildren,
        type: roomType,
        prices: [],
      };
      const ratesInfo = room.querySelectorAll('.unit__rate-plan');
      ratesInfo?.forEach((rate) => {
        const rateName = rate.querySelector('.unit__rate-plan-title')?.textContent;
        const nights = thn.parseNumber(rate.querySelector('.unit__rate-plan-select-info')?.textContent.split(',')[1]);
        const price = thn.parseNumber(rate.querySelector('.unit__rate-plan-price')?.textContent);
        let pricePerNight;
        if (price && nights) {
          pricePerNight = (Math.round(price / nights) * 100) / 100;
        }
        const rateInfo = {
          id: '',
          name: rateName,
          totalNight: pricePerNight,
          breakfast: !!rateName.match(/breakfast|śniadaniem|frühstück|doručkom|colazione|zajtrkom/i),
          refundable: true, // We can always cancel our reservation 4 days before check-in.
        };
        roomData.prices.push(rateInfo);
      });
      roomDetailsArray.push(roomData);
    });
    return roomDetailsArray;
  };

  /**
  * @memberOf module:bs_376
  * @this thn.widgets.booking
  * @see {@link Booking#set_data}
  *
  * @param {object} ctx - The context object.
  */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};

    // bookingId
    const bookingId = document.querySelector('.reservation-code span')?.textContent || thn.parseUrlParameter('rescode');

    if (!bookingId) {
      widgetData.set = false;
      return widgetData;
    }
    widgetData.bookingId = bookingId;

    // Dates
    widgetData.dateBegin = thn.parseUrlParameter('checkin')?.replace(/-/g, '/');
    widgetData.dateEnd = thn.parseUrlParameter('checkout')?.replace(/-/g, '/');

    // Prices & currency
    const priceSel = document.querySelector('#SummaryGrandTotalValue');
    widgetData.price = thn.parseNumber(priceSel?.textContent);
    widgetData.currency = thn.parseCurrency(priceSel?.textContent);

    return widgetData;
  };

  /**
         * @memberOf module:bs_382
         * @this thn.widgets.price
         * @see {@link Price#get_promocode}
         *
         * @param {object} ctx - The context object.
         */
  engine.getPromocode = function getPromocode(ctx) {
    ctx.promocode = thn.dataLayerHelper.get('promocode') || '';
    return ctx.promocode;
  };

  return engine;
}

export { factory };
